// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AthleteFilterController from "./athlete_filter_controller"
application.register("athlete-filter", AthleteFilterController)

import HotkeysController from "./hotkeys_controller"
application.register("hotkeys", HotkeysController)

import BootstrapModalController from "./bootstrap_modal_controller"
application.register("bootstrap-modal", BootstrapModalController)
